//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { intlFormat } from 'date-fns'

export default {
  props: {
    slug: {
      type: Number,
      default: null
    },
    startDate: {
      type: String,
      default: null
    },
    endDate: {
      type: String,
      default: null
    },
    place: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    img: {
      type: String,
      default: null
    },
    showBooking: {
      type: Boolean,
      default: true
    },
    link: {
      type: String,
      default: null
    }
  },
  data () {
    return {
    }
  },
  methods: {
    getEventDate (startDate, endDate) {
      try {
        const startDay = intlFormat(new Date(startDate), {
          day: 'numeric'
        }, {
          locale: this.$i18n.localeProperties.iso || 'en-US'
        })
        const startMonth = intlFormat(new Date(startDate), {
          month: 'long'
        }, {
          locale: this.$i18n.localeProperties.iso || 'en-US'
        })
        const startYear = intlFormat(new Date(startDate), {
          year: 'numeric'
        }, {
          locale: this.$i18n.localeProperties.iso || 'en-US'
        })
        const endDay = intlFormat(new Date(endDate), {
          day: 'numeric'
        }, {
          locale: this.$i18n.localeProperties.iso || 'en-US'
        })
        const endMonth = intlFormat(new Date(endDate), {
          month: 'long'
        }, {
          locale: this.$i18n.localeProperties.iso || 'en-US'
        })
        const endYear = intlFormat(new Date(endDate), {
          year: 'numeric'
        }, {
          locale: this.$i18n.localeProperties.iso || 'en-US'
        })
        if (startYear === endYear) {
          if (startMonth === endMonth) {
            return ''.concat(startDay, '-', endDay, ' ', endMonth, ' ', endYear)
          }
          const start = intlFormat(new Date(startDate), {
            month: 'long',
            day: 'numeric'
          }, {
            locale: this.$i18n.localeProperties.iso || 'en-US'
          })
          const end = intlFormat(new Date(endDate), {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
          }, {
            locale: this.$i18n.localeProperties.iso || 'en-US'
          })
          return ''.concat(start, ' - ', end)
        }
        const start = intlFormat(new Date(startDate), {
          month: 'long',
          day: 'numeric',
          year: 'numeric'
        }, {
          locale: this.$i18n.localeProperties.iso || 'en-US'
        })
        const end = intlFormat(new Date(endDate), {
          month: 'long',
          day: 'numeric',
          year: 'numeric'
        }, {
          locale: this.$i18n.localeProperties.iso || 'en-US'
        })
        return ''.concat(start, ' - ', end)
      } catch (err) {
        // console.log(err)
        if (typeof startDate === 'string' && typeof endDate === 'string') {
          return ''.concat(startDate.substring(0, 10), ' - ', endDate.substring(0, 10))
        }
        return ''
      }
    }
  }
}
